module.exports = "//docs.gtimg.com/slide/img/_/node_modules/@tencent/docs-design-resources/pc/svg/file_drive_xmind_16-f46262.svg";